<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-container" style="height: 100%; position: relative">
    <chat :user-list="list" :from-user="currentUser" />
  </div>
</template>

<script>
import { getUserList } from '@/api/chat'

export default {
  name: 'Chat',
  components: {
    chat: () => import('@/views/ita/components/chatComponents.vue'),
  },
  data() {
    return {
      list: [],
      currentUser: '',
    }
  },
  created() {
    this.currentUser = this.$store.state.user.account
    this.getUserList()
  },
  methods: {
    async getUserList() {
      await getUserList().then(response => {
        this.list = response.data
      })
    },
    fetchData() {},
    handleDownload() {},
  },
}
</script>

<style>
.app-main {
  position: absolute !important;
  height: 100%;
}
</style>
